export default __webpack_public_path__ + "static/EzyMedical_PDS(MV)-1b433be6eb194e641985db59ac7ca06f.pdf";